var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "data-nc": "true",
    className: "main-app-logostyles__Svg-sc-trcmqf-0 bjwIDe",
    viewBox: "18 23 35.1 23.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "default",
    transform: "matrix(.9 0 0 .9 18 23)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.002 19.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F84136",
    stroke: "none",
    strokeWidth: 1,
    d: "M13 13l13 13H0l13-13z",
    transform: "translate(-13 -19.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 13)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0071E1",
    stroke: "none",
    strokeWidth: 1,
    d: "M26.002 0l13 13L26 26 13.002 13l13-13z",
    transform: "translate(-26.002 -13)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC600",
    stroke: "none",
    strokeWidth: 1,
    d: "M26 0L13 13 0 0h26z",
    transform: "translate(-13 -6.5)"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ua-top",
    x1: "100%",
    y1: "27%",
    x2: "0%",
    y2: "73%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "34%",
    style: {
      stopColor: "rgb(0, 84, 179)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59%",
    style: {
      stopColor: "rgb(0, 101, 214)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ua-right",
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0, 87, 183)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49%",
    style: {
      stopColor: "rgb(0, 87, 183)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "rgb(255, 215, 0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255, 215, 0)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ua-bottom",
    x1: "100%",
    y1: "73%",
    x2: "0%",
    y2: "27%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    style: {
      stopColor: "rgb(250, 196, 0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    style: {
      stopColor: "rgb(255, 215, 0)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductboard);
export default __webpack_public_path__ + "static/media/productboard.c6c5cf9825640b65867c0b421e9dc694.svg";
export { ForwardRef as ReactComponent };